export default "__VITE_ASSET__TCGSwv_Y__"